import React, { useState } from 'react'
import { useDispatch } from 'react-redux'

import styles from './EnterprisePage.module.scss'

import CustomButton from 'components/elements/buttons/CustomButton'
import CustomInput from '../../components/elements/inputs/CustomInput'
import InputGroup from '../../components/elements/forms/InputGroup'
import { useSelector } from 'react-redux'
import { selectSubscriptionProcessing } from '../../store/pricing/selectors'
import { IBillingInfoData } from '../../models/pricing'
import { PricingActionsTypes } from '../../store/pricing/actions'

const EnterprisePage: React.FC = () => {
  const dispatch = useDispatch()

  const [planId, setPlanId] = useState('')
  const [name, setName] = useState('')
  const [country, setCountry] = useState('')
  const [zip, setZip] = useState('')

  const subscriptionProcessing = useSelector(selectSubscriptionProcessing)

  const handleFormSubmit = () => {
    let subscriptionData: IBillingInfoData = {
      plan_id: planId,
      name: name,
      country: country,
      zip_code: zip,
    }

    dispatch({
      type: PricingActionsTypes.PRICING_GET_INVOICE,
      subscriptionData,
    })
    dispatch({
      type: PricingActionsTypes.PRICING_ON_SUBSCRIPTION_PROCESSING,
    })
  }

  return (
    <div className={styles.container}>
      <div className={styles.form}>
        <div className={styles.title}>
          api/subscriptions - add custom plan to this cu
        </div>

        <InputGroup
          labelTop={'"plan_id": "9pts9w43u36zQmmp'}
          className={styles.inputGroup}
        >
          <CustomInput
            value={planId}
            onChange={(e) => setPlanId(e.target.value)}
            readOnly={subscriptionProcessing}
          />
        </InputGroup>

        <InputGroup
          labelTop={'"name": "Name Lastname"'}
          className={styles.inputGroup}
        >
          <CustomInput
            value={name}
            onChange={(e) => setName(e.target.value)}
            readOnly={subscriptionProcessing}
          />
        </InputGroup>

        <InputGroup labelTop={'"country": "us"'} className={styles.inputGroup}>
          <CustomInput
            value={country}
            onChange={(e) => setCountry(e.target.value)}
            readOnly={subscriptionProcessing}
          />
        </InputGroup>

        <InputGroup
          labelTop={'"zip_code": "90210"'}
          className={styles.inputGroup}
        >
          <CustomInput
            value={zip}
            onChange={(e) => setZip(e.target.value)}
            readOnly={subscriptionProcessing}
          />
        </InputGroup>

        <CustomButton
          wide
          className={styles.submitBtn}
          color={'blue'}
          onClick={handleFormSubmit}
          loading={subscriptionProcessing}
        >
          Apply custom plan
        </CustomButton>
      </div>
    </div>
  )
}

export default EnterprisePage
